/* tslint:disable */
/* eslint-disable */
/* @relayHash a6bd2994cc01e568d914edeb839ab8c6 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RefreshViewerFetchQueryVariables = {};
export type RefreshViewerFetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"StreamContainer_viewer">;
    } | null;
};
export type RefreshViewerFetchQuery = {
    readonly response: RefreshViewerFetchQueryResponse;
    readonly variables: RefreshViewerFetchQueryVariables;
};



/*
query RefreshViewerFetchQuery {
  viewer {
    ...StreamContainer_viewer
    id
  }
}

fragment CreateCommentMutation_viewer on User {
  id
  avatar
  badges
  bio
  createdAt
  role
  username
  status {
    current
    ban {
      active
    }
  }
}

fragment CreateCommentReplyMutation_viewer on User {
  role
  badges
  createdAt
  status {
    current
    ban {
      active
    }
  }
}

fragment ModerateStreamContainer_viewer on User {
  role
}

fragment PostCommentFormContainer_viewer on User {
  id
  scheduledDeletionDate
}

fragment StreamContainer_viewer on User {
  status {
    current
  }
  ...CreateCommentMutation_viewer
  ...CreateCommentReplyMutation_viewer
  ...ModerateStreamContainer_viewer
  ...PostCommentFormContainer_viewer
  ...StreamDeletionRequestCalloutContainer_viewer
  ...SuspendedInfoContainer_viewer
  ...UserBoxContainer_viewer
  ...WarningContainer_viewer
}

fragment StreamDeletionRequestCalloutContainer_viewer on User {
  scheduledDeletionDate
}

fragment SuspendedInfoContainer_viewer on User {
  status {
    suspension {
      until
    }
  }
}

fragment UserBoxContainer_viewer on User {
  username
}

fragment WarningContainer_viewer on User {
  status {
    warning {
      active
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "RefreshViewerFetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "RefreshViewerFetchQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SuspensionStatus",
                                    "kind": "LinkedField",
                                    "name": "suspension",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "until",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WarningStatus",
                                    "kind": "LinkedField",
                                    "name": "warning",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "message",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "avatar",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "badges",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bio",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "username",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "a6bd2994cc01e568d914edeb839ab8c6",
            "metadata": {},
            "name": "RefreshViewerFetchQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '2b6850f0951b6c249cd1df207ec58104';
export default node;
